(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-artistic-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ck-artistic-carousel')) {
  customElements.define('ck-artistic-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.ck-artistic-gallery__grid');
      const prev = this.querySelector('.ck-artistic-gallery__prev');
      const next = this.querySelector('.ck-artistic-gallery__next');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.hidden = next.hidden = max <= 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
      };
      const move = direction => {
        const card = track.querySelector('.ck-artistic-gallery__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', update, {passive: true, signal});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.ck-artistic-gallery__card');
        if (card) track.scrollTo({left: card.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'instant'});
      }, {signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-blazer-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ck-blazer-carousel')) {
  customElements.define('ck-blazer-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.ck-blazer-gallery__grid');
      const prev = this.querySelector('.ck-blazer-gallery__prev');
      const next = this.querySelector('.ck-blazer-gallery__next');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.hidden = next.hidden = max <= 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
      };
      const move = direction => {
        const card = track.querySelector('.ck-blazer-gallery__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', update, {passive: true, signal});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.ck-blazer-gallery__card');
        if (card) track.scrollTo({left: card.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'instant'});
      }, {signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-halloween-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ck-halloween-carousel')) {
  customElements.define('ck-halloween-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.ck-halloween-gallery__grid');
      const prev = this.querySelector('.ck-halloween-gallery__prev');
      const next = this.querySelector('.ck-halloween-gallery__next');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.hidden = next.hidden = max <= 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
      };
      const move = direction => {
        const card = track.querySelector('.ck-halloween-gallery__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', update, {passive: true, signal});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.ck-halloween-gallery__card');
        if (card) track.scrollTo({left: card.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'instant'});
      }, {signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-jacket-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ck-jacket-carousel')) {
  customElements.define('ck-jacket-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.ck-jacket-gallery__grid');
      const prev = this.querySelector('.ck-jacket-gallery__prev');
      const next = this.querySelector('.ck-jacket-gallery__next');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.hidden = next.hidden = max <= 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
      };
      const move = direction => {
        const card = track.querySelector('.ck-jacket-gallery__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', update, {passive: true, signal});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.ck-jacket-gallery__card');
        if (card) track.scrollTo({left: card.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'instant'});
      }, {signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-style-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ck-cardigan-carousel')) {
  customElements.define('ck-cardigan-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.ck-style-gallery__grid');
      const prev = this.querySelector('.ck-style-gallery__prev');
      const next = this.querySelector('.ck-style-gallery__next');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.hidden = next.hidden = max <= 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
      };
      const move = direction => {
        const card = track.querySelector('.ck-style-gallery__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', update, {passive: true, signal});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.ck-style-gallery__card');
        if (card) track.scrollTo({left: card.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'instant'});
      }, {signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
